import { render } from "./GymDocs.vue?vue&type=template&id=797e2987&scoped=true"
import script from "./GymDocs.vue?vue&type=script&lang=js"
export * from "./GymDocs.vue?vue&type=script&lang=js"

import "./GymDocs.vue?vue&type=style&index=0&id=797e2987&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797e2987"]])

export default __exports__